import type { RouteLocationNormalizedLoadedGeneric } from 'vue-router';
import { safeParse as vSafeParse } from 'valibot';
import dayjs from 'dayjs';
import { MarketingTrackingQuerySchema, type MarketingStorage, MARKETING_STORAGE_KEY } from '#shared/lead/marketing';
import type { NuxtApp } from '#app';

// https://iad-holding.atlassian.net/browse/WEB-749
export default defineNuxtPlugin({
  name: 'page-tracking',
  // https://nuxt.com/docs/api/advanced/hooks
  hooks: {
    'app:mounted'() {
      const nuxtApp = useNuxtApp();
      const route = useRoute();
      persistMarketingCampaign(nuxtApp, route);
    },
    'page:start'() {
      const nuxtApp = useNuxtApp();
      const route = useRoute();
      persistMarketingCampaign(nuxtApp, route);
    },
  },
});

function persistMarketingCampaign(nuxtApp: NuxtApp, route: RouteLocationNormalizedLoadedGeneric) {
  const queryResult = vSafeParse(MarketingTrackingQuerySchema, route.query);
  if (!queryResult.success) return;
  const trackingKeys = Object.keys(queryResult.output);
  const hasKeys = trackingKeys.length > 0;
  if (!hasKeys) return;
  const expiresAt = dayjs().add(1, `day`).unix();
  const marketingStorage: MarketingStorage = {
    parameters: {
      utmId: queryResult.output.utm_id,
      utmTerm: queryResult.output.utm_term,
      utmMedium: queryResult.output.utm_medium,
      utmSource: queryResult.output.utm_source,
      utmContent: queryResult.output.utm_content,
      utmCampaign: queryResult.output.utm_campaign,
      gclid: queryResult.output.gclid,
      fbclid: queryResult.output.fbclid,
    },
    expiresAt,
  };
  localStorage.setItem(MARKETING_STORAGE_KEY, JSON.stringify(marketingStorage));
}
